// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"5d201a0d","140":"54939d6c","147":"0711a264","461":"12622aba","574":"d2cde548","680":"167a682c","807":"fcbde5f4","818":"aa3af2a7","899":"e1acf0a9","900":"4582d9d9","919":"15fd24b1","984":"35a56347"}[chunkId] + ".chunk.js";
};